import { render, staticRenderFns } from "./ComposeCreat.vue?vue&type=template&id=175dfb98&scoped=true&"
import script from "./ComposeCreat.vue?vue&type=script&lang=js&"
export * from "./ComposeCreat.vue?vue&type=script&lang=js&"
import style0 from "./ComposeCreat.vue?vue&type=style&index=0&id=175dfb98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175dfb98",
  null
  
)

export default component.exports